import React from 'react';

import { IMAGE_PRESETS } from './presets';
import { ImageProps } from './types';
import { buildImageSrcSet, getFallbackImageSrc } from './utils';

const BaseImage = ({
  image,
  preset,
  alt,
  className,
  loading,
  style,
  sizes,
  ...props
}: ImageProps) => {
  const presetConfig = IMAGE_PRESETS[preset ?? 'default'];
  const resolvedLoading = loading || presetConfig.loading || 'lazy';
  const resolvedSrc = getFallbackImageSrc(image, presetConfig.src);
  const resolvedSrcSet = buildImageSrcSet(image);
  const resolvedSizes = sizes || presetConfig.sizes;

  if (!resolvedSrc) {
    return null;
  }

  return (
    <img
      src={resolvedSrc}
      srcSet={resolvedSrcSet || undefined}
      sizes={resolvedSrcSet ? resolvedSizes : undefined}
      alt={alt || (typeof image === 'object' && image !== null && 'name' in image ? image.name : '') || ''}
      className={className}
      loading={resolvedLoading}
      decoding="async"
      style={{
        objectFit: presetConfig.objectFit,
        borderRadius: presetConfig.round ? '50%' : undefined,
        ...style,
      }}
      {...props}
    />
  );
};

export const Image = React.memo(BaseImage);

export { IMAGE_PRESETS } from './presets';
export { buildImageSrcSet, getFallbackImageSrc, isApiImageObject, getRawImageSrc } from './utils';
export type { ImageProps, ImagePresetKey, ImagePresetConfig, ImageSourceKey, ApiImageObject, ImageSource } from './types';